import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollRestoration component:
 * - Main content (right side) ALWAYS scrolls to top on navigation
 * - Sidebar scroll is handled separately in Dashboard.js
 */
export default function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Always scroll main content to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
